export default __webpack_public_path__ + "images/embroidery_screen_f950da60989ea337d40cd5a195484991.jpg";